import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from "./components/Login";
import Privacy from "./components/Privacy";
import PrivacyLive from "./components/PrivacyLive";
import SmartKey from './components/Smartkey';
import Visit from './components/Visit';
import Client from './components/Client';
import ClientInfo from './components/ClientInfo';
import ClientInfoEdit from './components/ClientInfoEdit';
import ClientInfoAdd from './components/ClientInfoAdd';
import Center from './components/Center';
import CenterInfo from './components/CenterInfo';
import CenterInfoAdd from './components/CenterInfoAdd';
import CenterInfoEdit from './components/CenterInfoEdit';
import Purchase from './components/Purchase';
import PurchaseInfo from './components/PurchaseInfo';
import PurchaseInfoAdd from './components/PurchaseInfoAdd';
import PurchaseInfoEdit from './components/PurchaseInfoEdit';
import Teacher from './components/Teacher';
import TeacherInfo from './components/TeacherInfo';
import TeacherInfoEdit from './components/TeacherInfoEdit';
import TeacherInfoAdd from './components/TeacherInfoAdd';
import Item from './components/Item';
import Gate from './components/Gate';
import NewGate from './components/NewGate';
import Refund from './components/Refund';
import RefundInfo from './components/RefundInfo';
import RefundInfoAdd from './components/RefundInfoAdd';
import RefundInfoEdit from './components/RefundInfoEdit';
import styled from 'styled-components';
import Home from './components/Home';
import HgHome from './components/HgHome';
import ReservationBoard from './components/ReservationBoard';
import ReservationOnPopup from './components/ReservationOnPopup';
import Coupon from './components/Coupon';
import Reservation from './components/Reservation';
import Frequency from './components/Frequency';
import Reward from './components/Reward';
import Rating from './components/Rating';
import Report from './components/Report';
import Statistics from './components/Statistics';
import { Provider } from 'react-redux';
import store from './store'
import { useDispatch } from 'react-redux'
import PushLog from './components/PushLog';
import Setup from './components/Setup';
import Sms from './components/Sms';
import SmsExpire from './components/SmsExpire';
import SmsAll from './components/SmsAll';
import DiscountCoupon from './components/DiscountCoupon';
import PtCoupon from './components/PtCoupon';
import Test from './components/Test';
import Yuna from "./components/Yuna";


const MainContainer = styled.div`
`

function ReduxComponent() {
  const dispatch = useDispatch();
  dispatch({type:'GET', name:"URL"});
  return (
    <></>
  )
}

function App() {

  return (
    <Provider store={store}>
      <MainContainer className="App">
        <ReduxComponent></ReduxComponent>
        <Router>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/login" component={Login} />
            {/* {isLogin === true &&
            <> */}
            <Route exact path="/home" component={Home} />
            <Route exact path="/smartkey" component={SmartKey} />
            <Route exact path="/visit/:center/:sdate" component={Visit} />
            <Route exact path="/client" component={Client} />
            <Route exact path="/clientInfo/:mcd" component={ClientInfo} />
            <Route
              exact
              path="/clientInfoEdit/:mcd"
              component={ClientInfoEdit}
            />
            <Route exact path="/clientInfoAdd" component={ClientInfoAdd} />
            <Route exact path="/center" component={Center} />
            <Route exact path="/centerInfo/:cid" component={CenterInfo} />
            <Route exact path="/centerInfoAdd" component={CenterInfoAdd} />
            <Route
              exact
              path="/centerInfoEdit/:cid"
              component={CenterInfoEdit}
            />
            <Route exact path="/purchase" component={Purchase} />
            <Route exact path="/purchaseInfo/:pcd" component={PurchaseInfo} />
            <Route exact path="/purchaseInfoAdd" component={PurchaseInfoAdd} />
            <Route
              exact
              path="/purchaseInfoEdit/:pcd"
              component={PurchaseInfoEdit}
            />
            <Route exact path="/teacher" component={Teacher} />
            <Route exact path="/teacherInfo/:tcd" component={TeacherInfo} />
            <Route
              exact
              path="/teacherInfoEdit/:tcd"
              component={TeacherInfoEdit}
            />
            <Route exact path="/teacherInfoAdd" component={TeacherInfoAdd} />
            <Route exact path="/item" component={Item} />
            <Route exact path="/gate" component={Gate} />
            <Route exact path="/newGate" component={NewGate} />
            <Route exact path="/sms" component={Sms} />
            <Route exact path="/refund" component={Refund} />
            <Route exact path="/refundInfo/:seq" component={RefundInfo} />
            <Route exact path="/refundInfoAdd/:pcd" component={RefundInfoAdd} />
            <Route
              exact
              path="/refundInfoEdit/:seq"
              component={RefundInfoEdit}
            />
            <Route exact path="/setup" component={Setup} />
            <Route exact path="/pushLog" component={PushLog} />
            <Route exact path="/smsExpire" component={SmsExpire} />
            <Route exact path="/smsAll" component={SmsAll} />
            <Route exact path="/discountCoupon" component={DiscountCoupon} />
            {/* PT */}
            <Route exact path="/hg-home" component={HgHome} />
            <Route
              exact
              path="/reservationBoard"
              component={ReservationBoard}
            />
            <Route
              exact
              path="/reservationOnPopup"
              component={ReservationOnPopup}
            />
            <Route exact path="/hg-coupon" component={Coupon} />
            <Route exact path="/reservation" component={Reservation} />
            <Route exact path="/frequency" component={Frequency} />
            <Route exact path="/reward" component={Reward} />
            <Route exact path="/rating" component={Rating} />
            <Route exact path="/report" component={Report} />
            <Route exact path="/statistics" component={Statistics} />
            <Route exact path="/pt_coupon" component={PtCoupon} />
            {/* </>
            } */}
            <Route exact path="/privacy/:cid" component={Privacy} />
            <Route exact path="/privacyLive" component={PrivacyLive} />
            <Route exact path="/test" component={Test} />

            <Route exact path="/yuna" component={Yuna} />
          </Switch>
        </Router>
      </MainContainer>
    </Provider>
  );
}

export default App;